// extracted by mini-css-extract-plugin
export default {"mainContainer":"mainContainer___JCsdm","tableContainer":"tableContainer___Z3oVg","categoryName":"categoryName___Fn50i"};